import * as React from 'react';

import * as styles from './styles.css';
import { NBSP } from '../../../../constants/symbols';
import { IValuationFiltersProps } from '../../types/public';

export const ValuationFiltersDesktop: React.FC<IValuationFiltersProps> = ({
  mainFiltersWidget,
  valuationFiltersSubmit,
  buttonRef,
  containerRef,
}) => {
  return (
    <div ref={containerRef} className={styles['valuation_header']}>
      <div className={styles['title-container']}>
        <p className={styles['title']}>Оцените квартиру{NBSP}бесплатно</p>
      </div>
      <div className={styles['wrapper']}>
        <div className={styles['header_container']}>
          <div className={styles['wrapper_label']}>
            {mainFiltersWidget}
            <div className={styles['suburban_info']} />
          </div>
          <div ref={buttonRef} className={styles['wrapper_button']}>
            {valuationFiltersSubmit}
          </div>
        </div>
      </div>
    </div>
  );
};

ValuationFiltersDesktop.displayName = 'ValuationFiltersDesktop';
